module.exports = __webpack_public_path__ + "img/Mask Group 2915@2x.86378b37.png";